<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>医联体综合信息管理平台</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">医联体综合信息管理平台</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        在建立联合体综合信息管理平台，是深化医改的重要步骤和解决矛盾的制度创新。以区域三甲医院为龙头构建覆盖区域医疗机构的联合体，以满足联合体区域各级医疗机构需求为目标，以国家卫计委颁布政策规范标准为依据，以云计算大数据互联网技术为支撑，建设医联体综合信息管理平台。平台有利于优化医疗资源结构布局，推进优质医疗资源下沉，提升基层服务能力和整体服务效能。
        <br>
        医联体综合信息管理平台依托三甲医院优势医疗资源、整合专家资源和培训基地资源建立区域服务中心，以联合体内各地各级医疗机构、保健院、站、所和社区卫生服务中心（包括承担妇幼健康服务的公立、民营医疗机构）为分中心或应用终端，实现相互间的互联互通、业务协同、信息资源共享，创立医疗服务平台化、协同化和智能化新模式，最终建成一个政府、医院、患者、运营企业共赢的居民健康生态系统。<br><br>
        <span class="con_text">主要功能：</span>
        <br>
        实验室检验数据跟踪共享<br>
        实现联合体成员机构向中心院申请远程医学检验诊断、出具诊断意见及报告<br><br>

        影像云<br>
        实现联合体服务妇幼对象及患者病历信息的采集与存储（参考影像云介绍）<br><br>

        远程超声诊断<br>
        实现联合体成员机构向中心院申请远程超声影像诊断，出具诊断指导意见及报告、以及
        对超声影像集中存储、集中诊断和管理（参考超声在线介绍）<br><br>

        远程会诊、双向转诊<br>
        实现联合体成员机构向中心院申请远程会诊，开展异地指导检查、协助诊断、指导诊疗
        等医疗活动（出具诊断意见及报告）；或对联合体成员机构遭遇的疑难重症患者，可向中心
        院申请转诊的确认、转入、转出管理过程。<br><br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product3s.png" /></div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 80%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>